import { render, staticRenderFns } from "./ShowsTable.vue?vue&type=template&id=45351bb2&"
import script from "./ShowsTable.vue?vue&type=script&lang=js&"
export * from "./ShowsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports